<template></template>

<script>
import { mapActions } from 'vuex'
import LensAPI from '@/api/lens'

export default {
  name: 'LensPlatformAuthenticator',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  beforeDestroy () {
    if (this._authPopupInterval) {
      clearInterval(this._authPopupInterval)
    }
  },
  methods: {
    ...mapActions('LensModule', ['fetchSidebarLenses']),
    async handlePlatformAuthenticate (platform) {
      return new Promise(async (resolve, reject) => {
        if (this.loading || (this._popup && !this._popup.closed)) {
          console.error('Platform authentication already in progress')
          return reject(new Error('Platform authentication already in progress'))
        }
        try {
          const authURL = await LensAPI.Lens.getPlatformAuthURL(platform)

          // Open auth popup window
          this._popup = window.open(authURL, 'auth-popup', 'width=600,height=600,scrollbars=yes,resizable=yes')
          if (!this._popup) {
            return reject(new Error('Popup was blocked. Please allow popups for this site.'))
          }

          // Handle popup closure
          this._authPopupInterval = setInterval(async () => {
            if (this._popup.closed) {
              clearInterval(this._authPopupInterval)
              this._popup = null
              await this.fetchSidebarLenses()
              resolve()
            }
          }, 300)
        } catch (error) {
          this.$showAlert({
            type: 'error',
            message: 'Failed to get authentication URL. See console for details'
          })
          this._popup = null
          reject(error)
        }
      })
    }
  }
}
</script>